import React from 'react';
import Card from '@material-ui/core/Card';
import {CardHeader, CardContent} from '@material-ui/core';
import SmLine from '../../charts/line/sm-line';
import LensIcon from "@material-ui/icons/Lens";
import {useTranslation} from "react-i18next";

interface TemperatureLineCardProps {
    name: string;
    width: number;
    names: any[];
    allNames: any;
}

const TemperatureLineCard: React.FC<TemperatureLineCardProps> = (props: TemperatureLineCardProps) => {
    const { t } = useTranslation();
    return (
        <Card className=''>
            <div className='d-flex justify-content-between custom-card-title'>
                <span className='card-title'>{t('chart')}</span>
            </div>
            <CardContent className='temperature-card-content'>
                <SmLine allNames={props.allNames} names={props.names} width={props.width}/>
            </CardContent>
        </Card>
    )
};

export default TemperatureLineCard;